import { Outlet } from "react-router-dom";
import { AuthSessionProvider } from "@/lib/auth-client";
import { ThemeSync } from "./ThemeSync";
import { PWAProvider } from "./pwa/PWAProvider";

export function RootLayout() {
  return (
    <AuthSessionProvider>
      <PWAProvider>
        <ThemeSync />
        <Outlet />
      </PWAProvider>
    </AuthSessionProvider>
  );
}
